import DiscountsApi from "../store/services/DiscountsApi";
import AnnouncementsApi from "../store/services/AnnouncementsApi";
import CardsApi from "../store/services/CardsApi";
import FirstAccessApi from "../store/services/FirstAccessApi";
import UserInfoApi from "../store/services/UserInfoApi";
import RedefinePasswordApi from "../store/services/RedefinePasswordAPI";
import CreateCardApi from "../store/services/CreateCardApi";
import ServicesApi from "../store/services/ServicesApi";
export default function useApi() {
	return {
		discounts: new DiscountsApi(),
		announcements: new AnnouncementsApi(),
		cards: new CardsApi(),
		firstAccess: new FirstAccessApi(),
		userInfo: new UserInfoApi(),
		redefinePassword: new RedefinePasswordApi(),
		createCard: new CreateCardApi(),
		services: new ServicesApi(),
	};
}
